import axios from 'axios'
import config from '../../../../../../config/environment';

export default async function getEquivalentData(state, amount, captchaToken) {
    const { inCurrency, outCurrency, payway, swapCurrencyButtonName, cashbackToken } = state;

    if (!inCurrency || !outCurrency || !payway || !amount) {
        return null
    }

    const body = {
        inCurrencyCode: inCurrency,
        outCurrencyCode: outCurrency,
        paywayCode: payway,
        amountData: {
            amount: amount,
            side: swapCurrencyButtonName === inCurrency ? 'IN' : 'OUT'
        },
        cashbackToken,
        captchaToken
    }

    try {
        const response = await axios.post(config.backendUrl + '/provider/get-profit-providers', body)
            .catch(error => {
                throw new Error('API v.3 error | ' + error.response.data.message)
            })

        if (response.data.variants.length === 0) {
            throw new Error('API v.3 error | No variants. Check request body.')
        }

        if (!response.data.variants[0].equivalentData || response.data.variants[0].equivalentData.status !== 'SUCCESS') {
            throw new Error('API v.3 error | No equivalentData or equivalent status is FAIL')
        }
        const result = state.exchangeWayId ? response.data.variants.find(way => state.exchangeWayId === way.exchangeWayId) : response.data.variants[0]
        return result

    } catch (error) {
        console.log(error.message);
        return null
    }
}